import differenceInMinutes from 'utils/time/differenceInMinutes';

export function calculateIntervalMinutes(
  startTime: Date,
  endTime: Date,
  numSlices: number,
): number {
  const totalMinutes = differenceInMinutes(endTime, startTime);
  if (numSlices <= 0) return 0;
  return Math.floor(totalMinutes / numSlices);
}
